const { subAccountType } = require('@transfeeradev/api-enums/subaccount');

class AccountService {
  static getAccountableCompanyId(company) {
    if (company.parentId) {
      return company.parentId;
    }

    return company.id;
  }

  static isParentAccount(company) {
    return !company.subAccountType;
  }

  static isOwnAccount(company) {
    return company.subAccountType === subAccountType.OWN;
  }
}

module.exports = AccountService;
